import React, { useState } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import SwipeableViews from "react-swipeable-views";

import { AboutModalTab } from "./AboutModalTab/AboutModalTab";
import AboutAzad from "./AboutAzad";
// import OurTeam from "./OurTeam/index";
import ContactUs from "./ContactUs";

const StyleBottomNav = styled(BottomNavigationAction)(({ theme }) => ({
  "&.MuiBottomNavigationAction-root": {
    borderRadius: "7px",
    paddingTop: "3px",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: theme.palette.black.main,
  },
  "&.MuiBottomNavigationAction-root.Mui-selected": {
    backgroundColor: theme.palette.black.main,
    color: theme.palette.white.main,
    fontWeight: 700,
  },
}));

const AboutPage = () => {
  const [aboutTab, setAboutTab] = useState(0);
  const theme = useTheme();

  return (
    <Box>
      <Box
        sx={{
          position: "fixed",
          height: "64px",
          top: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          backgroundColor: "white.main",
        }}
      >
        <Typography sx={{ fontSize: "20px" }}>About us</Typography>
      </Box>

      <Box
        sx={{
          position: "fixed",
          width: "100%",
          top: "64px",
          backgroundColor: "white.main",
        }}
      >
        <Box
          style={{
            width: "100%",
            padding: "16px 16px 0px",
          }}
        >
          <BottomNavigation
            sx={{
              height: "48px",
              boxShadow: `0px 0px 0px 2px ${theme.palette.black.main}`,
              borderRadius: "8px",
              overflow: "hidden",
              fontSize: "16px",
              marginBottom: "12px",
              width: "80%",
              mx: "auto",
            }}
            value={aboutTab}
            onChange={(e, a) => setAboutTab(a)}
          >
            <StyleBottomNav value={0} icon={"About Azad"} />
            {/* <StyleBottomNav value={1} icon={"Our team"} /> */}
            <StyleBottomNav value={1} icon={"Contact us"} />
          </BottomNavigation>
        </Box>
        <SwipeableViews
          style={{
            width: "100%",
            padding: "0 16px ",
          }}
          index={aboutTab}
          onChangeIndex={(e) => setAboutTab(e)}
        >
          <AboutModalTab value={aboutTab} index={0}>
            <AboutAzad />
          </AboutModalTab>

          {/* <AboutModalTab value={aboutTab} index={1}>
            <OurTeam />
          </AboutModalTab> */}

          <AboutModalTab value={aboutTab} index={1}>
            <ContactUs />
          </AboutModalTab>
        </SwipeableViews>
      </Box>
    </Box>
  );
};

export default AboutPage;
